import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const ReportKeywordForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const initialValues = {
    keyword: props.data ? props.data.Keyword : "",
  };
  const validationSchema = yup.object().shape({
    keyword: yup.string().required("Keyword required"),
  });
  const handleSubmit = async (values, { setSubmitting }) => {
    const { keyword } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, keyword }
      : { keyword };

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateExcludedreportkeywords" : "createReportKeyword",
      variables,
      mutationObjectName: "functionParams",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Report Keyword",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Industry Type" : "Create Industry Type"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Industry Type"
            : "Create a New Industry Type"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="KeyWord**"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="keyword"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default ReportKeywordForm;
